export default "__VITE_ASSET__7b6de8cf__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg16__"